import React from 'react';
import PersonalWorkspaceCard from './PersonalWorkspaceCard';

function PersonalWorkspacesSection({
  workspaces,
  onCreateWorkspace,
  onEditWorkspace,
  onDeleteWorkspace,
  onDuplicateWorkspace,
  onWorkspaceClick,
  editingWorkspace,
  editedWorkspaceName,
  onEditNameChange,
  onSaveEdit,
  isLoading
}) {
  return (
    <section>
      {workspaces.length > 0 && (
        <div className="mb-6 sm:mb-8">
          <button
            onClick={onCreateWorkspace}
            className="w-full sm:w-auto px-4 py-2 bg-cranberry-700 text-white rounded-xl border-2 border-neutral-900 font-medium hover:bg-cranberry-600 transition-colors shadow-sm text-sm sm:text-base"
          >
            Create Workspace
          </button>
        </div>
      )}

      <h2 className="text-base sm:text-lg font-semibold text-neutral-900 mb-3 sm:mb-4">
        Your Workspaces
      </h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {workspaces.map((workspace) => (
          <PersonalWorkspaceCard
            key={workspace.id}
            workspace={workspace}
            onEdit={onEditWorkspace}
            onDelete={onDeleteWorkspace}
            onDuplicate={onDuplicateWorkspace}
            onClick={onWorkspaceClick}
            isEditing={editingWorkspace?.id === workspace.id}
            editedName={editedWorkspaceName}
            onEditNameChange={onEditNameChange}
            onSaveEdit={onSaveEdit}
            isLoading={isLoading}
          />
        ))}

        {workspaces.length === 0 && (
          <div className="col-span-full text-center py-8 sm:py-12 bg-white rounded-xl border-2 border-neutral-200">
            <p className="text-sm sm:text-base text-neutral-600 mb-4">No workspaces yet</p>
            <button
              onClick={onCreateWorkspace}
              className="px-4 py-2 bg-cranberry-700 text-white rounded-xl border-2 border-neutral-900 font-medium hover:bg-cranberry-600 transition-colors text-sm sm:text-base"
            >
              Create Your First Workspace
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default PersonalWorkspacesSection; 